import { useContext } from "react";
import { ReactReduxContext } from "react-redux";

const useCheckPlan = () => {
    const { store } = useContext(ReactReduxContext);
    const { getState, dispatch } = store;
    const state = getState();

    const plan = state.userReducer.plan;
    const user = state.userReducer.user;

    /**
     * Check User Plan For Have OR Expire
     */
    const checkPlan = () => {
        if (plan) {
            const epiration = plan.expired_at;
            if (new Date(epiration).getTime() < new Date().getTime()) {
                return false;
            } else {
                return true;
            }
        } else {
            return false;
        }
    };

    /**
     * Check User Telegram for Connected Or Not
     */
    const checkTelegram = () => {
        if (checkPlan() && !user.telegram_id) {
            return false;
        } else {
            return true;
        }
    };

    return [checkPlan, checkTelegram];
};

export default useCheckPlan;